module.exports = __webpack_public_path__ + "static/media/back-arrow.fe31014a.svg";